export default __webpack_public_path__ + "static/media/cctv.352102ec.svg";